import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css'
})
export class EmptyStateComponent {
  @Input() type: any;
  @Input() getObj: any;
  backgroundPosition = ''
  dataObj = {
    booking: {
      bg_position: '-258px -188px',
      description: 'No bookings have set sail yet!',
    },
    rate_search: {
      bg_position: '-562px -188px',
      description: 'No rate found for the selected dates. Please adjust port details or dates, or request a rate. Our team will get back to you shortly.',
    },
    rate_search_vessel: {
      bg_position: '-562px -188px',
      description: 'No rate found for the selected dates. Please adjust port details or dates, or request a rate. Our team will get back to you shortly.',
    },
    recent_search: {
      bg_position: '-261px 30px',
      description: 'Portal is Peaceful - No recent rate searches',
    },
    quote: {
      bg_position: '41px -188px',
      description: 'No saved quotes. Dive in to snag fresh ones!',
    },
    documents: {
      bg_position: '-573px 30px',
      description: 'No documents to show',
    },
    timeline: {
      bg_position: '40px 30px',
      description: 'Shipment not yet underway',
    },
    todo: {
      bg_position: '-261px -412px',
      description: 'No tasks in line, everything\'s done for now!',
    },
    invoice: {
      bg_position: '37px -412px',
      description: 'No invoices around',
    },
    vessel_schedule: {
      bg_position: '-566px -412px',
      description: '',
    },
    reports: {
      bg_position: '-566px -412px',
      description: 'Aw snap! Reports unavailable',
    },
  };
  data: any;
  constructor() { }

  ngOnInit(): void {
    this.setEmptyStatus();
  }

  setEmptyStatus() {
    if (!!this.dataObj[this.type]) {
      this.data = this.dataObj[this.type];
    } else {
      this.data = this.dataObj['alright'];
    }
  }
}
